import script from "./input.vue?vue&type=script&lang=js"
export * from "./input.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/horizontal/input.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b0448ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b0448ba', __exports__)) {
    console.log('reload')
    api.reload('0b0448ba', __exports__)
  }
  
}


export default __exports__